import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "all",
  sortBy: "default",
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilterStatus: (state, action) => {
      state.status = action.payload;
    },
    setFilterBySorting: (state, action) => {
      state.sortBy = action.payload;
    },
  },
});

export const { setFilterStatus, setFilterBySorting } = filterSlice.actions;

export default filterSlice.reducer;
